(function () {
    'use strict';

    /**
     * The 'rootNavigationItem' property used below on some routes is not a standard part of the $routeProvider,
     * it's used by ChilliDocs NavigationAidService.
     */

    angular.module('app')
        .config(['$routeProvider', function ($routeProvider) {
            $routeProvider
                .when('/notes/:id', {
                    templateUrl: 'app/note/note-edit.html'
                })
                .when('/entitytemplates/navlist', {
                    templateUrl: 'app/sidemenu/entity-template-nav-list.tmpl.html',
                    rootNavigationItem: true
                })
                .when('/entitytemplates', {
                    templateUrl: 'app/sidemenu/entity-templates-list.html'
                })
                .when('/entitytemplates/:id', {
                    templateUrl: 'app/entitytemplate/entity-template-edit.html'
                })
                .when('/entities', {
                    templateUrl: 'app/sidemenu/entities-list.html'
                })
                .when('/entities/:id', {
                    templateUrl: 'app/entity-edit.html',
                    controller: 'EntityEditCtrl',
                    controllerAs: 'vm'
                })
                .when('/files/:id', {
                    templateUrl: 'app/files/file-edit.html'
                })
                .when('/user', {
                    templateUrl: 'app/entity-edit.html',
                    controller: 'UserProfileEditCtrl',
                    controllerAs: 'vm',
                    rootNavigationItem: true
                })
                .when('/email/:id', {
                    templateUrl: 'app/email/email-edit.html'
                })
                .when('/documenttemplates', {
                    templateUrl: 'app/sidemenu/document-templates-list.html'
                })
                .when('/documenttemplates/:id', {
                    templateUrl: 'app/documenttemplate/document-template-edit.html'
                })
                .when('/emailtemplates', {
                    templateUrl: 'app/sidemenu/email-templates-list.html'
                })
                .when('/emailtemplates/:id', {
                    templateUrl: 'app/emailtemplate/email-template-edit.html'
                })
                .when('/dashboardsettings/:id', {
                    templateUrl: 'app/dashboardsetting/dashboard-setting-edit.html'
                })
                .when('/smstemplates', {
                    templateUrl: 'app/sidemenu/sms-templates-list.html'
                })
                .when('/smstemplates/:id', {
                    templateUrl: 'app/smstemplate/sms-template-edit.html'
                })
                .when('/tasks', {
                    templateUrl: 'app/sidemenu/task-list.html',
                    rootNavigationItem: true
                })
                .when('/tasks/:id', {
                    templateUrl: 'app/task/task-edit.html'
                })
                .when('', {
                    redirectTo: '/dashboard'
                })
                .when('/', {
                    redirectTo: '/dashboard'
                })
                .when('/dashboard', {
                    templateUrl: 'app/dashboard/home.html',
                    rootNavigationItem: true
                })
                .when('/dashboard/setting', {
                    templateUrl: 'app/setting/dashboard-setting.html'
                })
                .when('/sms', {
                    templateUrl: 'app/sms/sms-compose.tmpl.html'
                })
                .when('/sms/:id', {
                    templateUrl: 'app/sms/sms-view.html'
                })
                .when('/system/setting', {
                    templateUrl: 'app/setting/system-setting.html',
                    rootNavigationItem: true
                })
                .when('/system/tags', {
                    templateUrl: 'app/setting/tag-setting.html'
                })
                .when('/tags/:id', {
                    templateUrl: 'app/tag/tag-edit.html'
                })
                .when('/system/xerointegration', {
                    templateUrl: 'app/setting/xero-integration.html'
                })
                .when('/system/setting/other', {
                    templateUrl: 'app/setting/system/system-setting-list.html'
                })
                .when('/system/setting/other/:id', {
                    templateUrl: 'app/setting/system/system-setting-edit.html'
                })
                .when('/system/setting/communication', {
                    templateUrl: 'app/setting/communication/communication-setting-edit.html'
                })
                .when('/system/emailaddress', {
                    templateUrl: 'app/setting/emailaddress/email-address-list.html'
                })
                .when('/system/emailaddress/:id/audit', {
                    templateUrl: 'app/setting/emailaddress/email-address-audit-list.html'
                })
                .when('/system/deleteditem', {
                    templateUrl: 'app/setting/deleteditem/deleted-items-list.html'
                })
                .when('/system/emailaddress/:id/email', {
                    templateUrl: 'app/setting/emailaddress/email-address-emails-list.html'
                })
                .when('/system/emailaddress/:id/entity', {
                    templateUrl: 'app/setting/emailaddress/email-address-entities-list.html'
                })
                .when('/system/user', {
                    templateUrl: 'app/setting/user-list.html'
                })
                .when('/workflow', {
                    templateUrl: 'app/workflow/workflow-home.html'
                })
                .when('/workflow/:id', {
                    templateUrl: 'app/workflow/workflow-edit.html'
                })
                .when('/workflow/:id/history', {
                    templateUrl: 'app/workflow/workflow-history.html'
                })
                .when('/runworkflow/:id', {
                    templateUrl: 'app/workflow/workflow-run.html'
                })
                .when('/login', {
                    templateUrl: 'app/auth/login.html'
                })
                .otherwise({
                    templateUrl: 'app/not-found.html'
                });
        }]);
})();